import { Divider } from "@ds/react";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import { ReactComponent as WarningBlue } from "assets/icons/warning-blue.svg";
import {
  qtyPrize750,
  qtyPrize115,
  qtyPrize190,
  qtyPrize1900,
  qtyPrize376,
  valuePerTitle,
} from "constants/sorteios";
import { useAppContext } from "contexts/AppContext";
import { useNavigate } from "react-router-dom";
import * as S from "./Resumo.styles";
import Tooltip from "components/Tooltip";
import ActionFooter from "components/ActionFooter/ActionFooter";
import { getCurrency } from "utils/currency";
import { concordanceByLength } from "utils/string";

const Resumo = () => {
  const { titleAmount } = useAppContext();
  const navigate = useNavigate();

  return (
    <section>
      <Section>
        <ResponsiveCard
          maxContent
          title="Detalhes da sua compra"
          description="Confira os dados do seu título, efetue a compra e cruze os dedos :)"
        >
          <S.ContentTituloInfoContainer>
            <S.StyledTitle as="p">Tipo de título</S.StyledTitle>
            <S.ContentTooltip>
              <S.StyledTitle as="p" className="isMarginRight">
                Pagamento único
              </S.StyledTitle>
              <Tooltip
                title="Pagamento único"
                description="Cobrança feita em uma única parcela, sem valores adicionais."
              >
                <WarningBlue data-label="resumo warning-blue" />
              </Tooltip>
            </S.ContentTooltip>
          </S.ContentTituloInfoContainer>

          <Divider />

          <S.ContentTituloInfoContainer>
            <S.StyledTitle as="p">Valor por título</S.StyledTitle>
            <S.StyledTitle as="p">{getCurrency(valuePerTitle)}</S.StyledTitle>
          </S.ContentTituloInfoContainer>

          <Divider />

          <S.ContentTituloInfoContainer>
            <S.StyledTitle as="p">Vigência e carência</S.StyledTitle>
            <S.ContentTooltip>
              <S.StyledTitle className="isMarginRight" as="p">
                12 meses
              </S.StyledTitle>
              <Tooltip
                title="Vigência e carência"
                description={
                  <>
                    A vigência é o prazo que o cliente concorre aos prêmios. Ela
                    se inicia na data de aquisição.
                    <br />
                    <br />A carência é o período de permanência do cliente com o
                    produto. Se inicia a partir da aquisição e permite um
                    resgate ao final do período de vigência. No caso de
                    pagamento único, o cliente resgata parte do valor do título.
                  </>
                }
              >
                <WarningBlue data-label="resumo warning-blue" />
              </Tooltip>
            </S.ContentTooltip>
          </S.ContentTituloInfoContainer>

          <Divider />

          <S.ContentTituloInfoContainer>
            <S.StyledTitle as="p">Quantidade</S.StyledTitle>
            <S.StyledTitle as="p">
              {titleAmount}{" "}
              {concordanceByLength(titleAmount, "título", "títulos")}
            </S.StyledTitle>
          </S.ContentTituloInfoContainer>

          <Divider />

          <S.WrapperContentSorteio>
            <S.ContentTituloInfoContainer>
              <S.StyledTitle as="p">Sorteio</S.StyledTitle>
              <S.StyledTitle className="small" as="p">
                Prêmios mensais
              </S.StyledTitle>
            </S.ContentTituloInfoContainer>
            <S.PrizeContainer>
              <S.PrizeText>{qtyPrize115} prêmios mensais de R$ 115</S.PrizeText>
              <S.PrizeText>{qtyPrize190} prêmios mensais de R$ 190</S.PrizeText>
              <S.PrizeText>{qtyPrize376} prêmios mensais de R$ 376</S.PrizeText>
              <S.PrizeText>{qtyPrize750} prêmios mensais de R$ 750</S.PrizeText>
              <S.PrizeText>
                {qtyPrize1900} prêmios mensais de R$ 1.900
              </S.PrizeText>
              <S.StyledTitle isMarginTop className="small" as="p">
                Prêmio único
              </S.StyledTitle>
              <S.PrizeText as="p">1 prêmio único de R$ 1.000.000</S.PrizeText>
            </S.PrizeContainer>
          </S.WrapperContentSorteio>

          <Divider />

          <S.ContentTituloInfoContainer>
            <S.StyledTitle className="bold" as="p">
              Valor a total a pagar
            </S.StyledTitle>
            <S.StyledTitle className="bold" as="p">
              {getCurrency(valuePerTitle * titleAmount)} à vista
            </S.StyledTitle>
          </S.ContentTituloInfoContainer>

          <Divider />

          <ActionFooter
            primaryAction={() => navigate("/unico/dados-pessoais")}
            goBackTo="/unico"
            primaryLabel="Quero comprar"
          />
        </ResponsiveCard>
      </Section>
    </section>
  );
};

export default Resumo;
